import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { OnbPageURLs } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { ISelectedRequest } from 'legacy/lut/classes/services/PartnerStoreService'
import { lookupGetStateOld, setNextLookupState } from 'legacy/lut/store'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { getUrlWithParams } from 'core-components/helpers/url'

export const REQ_NAV_STORAGE_KEY = 'onboarding_opened_requests'

export enum RequestLink {
  Onboarding = 'onb-requests',
  Exception = 'commercial-exceptions',
  Contract = 'contract-requests',
  RetailException = 'retail-exceptions',
  RetailOnboarding = 'onboarding-retail',
  BPRegistration = 'bp-registration-requests',
}

type TRequestDataToOpen = Pick<IRequest, 'EntryId' | 'PartnerName' | 'Type'>

interface IOpenRequestProps {
  item: TRequestDataToOpen
  url?: string
  sameTab?: boolean
}

export const useOpenRequest = () => {
  const navigate = useNavigate()

  const openRequest = useCallback(
    ({ item, url, sameTab }: IOpenRequestProps) => {
      const lookupOldState = lookupGetStateOld()

      const openedRequest: ISelectedRequest[] = [
        ...lookupOldState.onboarding.openedRequests,
      ].filter((el) => +el.reqId !== item.EntryId)
      openedRequest.unshift({
        reqId: `${item.EntryId}`,
        partnerName: item.PartnerName,
        type: RequestLink[item.Type],
      })

      localStorage.setItem(REQ_NAV_STORAGE_KEY, JSON.stringify(openedRequest))

      setNextLookupState({
        ...lookupOldState,
        onboarding: { ...lookupOldState.onboarding, openedRequests: openedRequest },
      })
      const requestUrl = getUrlWithParams(
        {
          rid: item.EntryId,
        },
        `page/${url || OnbPageURLs.RequestDetail}`
      )
      if (sameTab) {
        navigate(requestUrl)
      } else {
        window.open(requestUrl, '_blank')
      }
    },
    [navigate]
  )

  return { openRequest }
}
